module.exports = __webpack_public_path__ + "a51eb052c5a421fc0feeb63e97580908.png";